<ng-container #dynamicInputContainer>
</ng-container>
